import { AnimatePresence, motion } from "framer-motion";
import React from "react";

import { Icon } from "atoms/icon/Icon";
import CameraFlip from "atoms/icon/icons/camera_flip.svg";
import Close from "atoms/icon/icons/close.svg";
import AddedToCartCheck from "atoms/icon/icons/ic_added_to_cart_check_ol.svg";

export interface ToolStatusLineProps {
  toolName: string;
  toolId: string;
  status: "pending" | "success" | "failed";
  errorMessage?: string;
  enableAnimation?: boolean;
}

const StatusIcon = ({ status }: { status: ToolStatusLineProps["status"] }) => {
  switch (status) {
    case "pending":
      return (
        <Icon
          svg={CameraFlip}
          color="secondaryText"
          size="x3small"
          className="animate-spin"
        />
      );
    case "success":
      return (
        <Icon svg={AddedToCartCheck} color="secondaryText" size="x3small" />
      );
    case "failed":
      return <Icon svg={Close} color="secondaryText" size="x3small" />;
    default:
      return null;
  }
};

export const ToolStatusLine = ({
  toolName,
  toolId,
  status,
  enableAnimation = true,
}: ToolStatusLineProps) => {
  const content = (
    <div className="flex items-center gap-1 text-sm">
      <StatusIcon status={status} />
      <span className="text-xs font-normal text-gray-700">{toolName}</span>
    </div>
  );

  if (!enableAnimation) {
    return <div>{content}</div>;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        key={toolId}
      >
        {content}
      </motion.div>
    </AnimatePresence>
  );
};
